module.exports = __webpack_public_path__ + "24b08b0cd2f43997a968b3732528de2c.MP3";